/* eslint-disable react/self-closing-comp,react/no-danger,jsx-a11y/anchor-has-content */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import Slider from "react-slick";
import "./_yitm__general.scss";
import {filterUrl, isInternalLink} from "../../helpers/filters";

const GET_COMPONENT = gql`
query paragraphRevisionById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphMobileComponentDownloadCards {
          fieldInnerDownloadCards {
            entity {
              ... on ParagraphInnerDownloadCard {
                fieldExcerptIntro
                fieldTxtHeadline
                fieldTxtSubTitle
                fieldLink {
                  uri
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

class MobileComponentDownloadCard extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        markComponentLoadedAs: PropTypes.func.isRequired
    };

    static defaultProps = {
        componentIndex: null
    };

    render() {
        const {id, markComponentLoadedAs} = this.props;

        return (
            <Query asyncMode query={GET_COMPONENT} variables={{ id }}>
                {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) {
                        markComponentLoadedAs(id, true);
                        return <div>{error}</div>;
                    }

                    const cards = data.paragraphById.fieldInnerDownloadCards;

                    markComponentLoadedAs(id, true);

                    return (
                        <section className="yitm__contentSlider yitm__slider">
                            <Slider
                                swipeToSlide
                                slidesToShow={1}
                                slidesToScroll={1}
                                dots
                                infinite={false}
                                variableWidth
                                prevArrow={<button type="button" className="slick-prev"><span className="far fa-angle-left" /></button>}
                                nextArrow={<button type="button" className="slick-next"><span className="far fa-angle-right" /></button>}
                            >


                                {cards.map(card => (
                                    <div className="yitm__contentSlide">
                                        <a className="yitm__contentSlideTarget"
                                           target={isInternalLink(card.entity.fieldLink.uri) ? '_self' : '_blank'}
                                           rel={isInternalLink(card.entity.fieldLink.uri) ? null : 'noopener noreferrer'}
                                           href={filterUrl(card.entity.fieldLink.uri)}>
                                        <span>Read the full report.</span></a>
                                        <div className="yitm__contentSlideMain">
                                            <span className="yitm__contentSlideCat">{card.entity.fieldTxtSubTitle}</span>
                                            <h3 className="yitm__contentSlideTitle">{card.entity.fieldTxtHeadline}</h3>

                                            <p className="yitm__contentSlideText" dangerouslySetInnerHTML={{__html: card.entity.fieldExcerptIntro}}/>

                                            <span className="yitm__contentSlideCta">Read the full report.</span>
                                        </div>
                                        <span className="yitm__contentSlideIcon">
                                            <span className="fal fa-arrow-to-bottom" aria-hidden="true" />
                                        </span>
                                    </div>
                                ))}


                            </Slider>
                        </section>
                    );
                }}
            </Query>
        )
    }

}


export default MobileComponentDownloadCard;



// WEBPACK FOOTER //
// ./frontend/components/YITMMobile/MobileComponentDownloadCard.jsx